import { useAuthLogout } from '@/app/hooks/auth/useAuthLogout'
import { isValidRedirect } from '@/app/lib/auth'
import { ROUTES } from '@/app/lib/constants'
import { useEffect } from 'react'
import { useQueryClient } from 'react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function AuthLogoutPage() {
  const { mutateAsync: logout } = useAuthLogout()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const queryClient = useQueryClient()

  const redirectTo = searchParams.get('redirectTo') ?? ROUTES.homepage

  useEffect(() => {
    ;(async () => {
      try {
        await logout()
      } catch {
        // Ignore logout errors
      }

      const queryParams = new URLSearchParams()
      if (isValidRedirect(redirectTo)) {
        queryParams.set('redirectTo', redirectTo)
      }

      const loginPath = queryParams.toString()
        ? `${ROUTES.login}?${queryParams.toString()}`
        : ROUTES.login

      navigate(loginPath, { replace: true })
    })()
  }, [logout, navigate, redirectTo, queryClient])

  return null
}
